import { mapGetters } from 'vuex';
import { processList } from '../process-list.js';
// import { errorMessage } from '@/utils/message.js';
import Header from '@/components/header/index.vue';
import Search from '@/components/search/index.vue';
import Menu from '@/components/menu/index.vue';
import Bottom from '@/components/bottom/index.vue';
import ProcessNavigation from '@/components/process-navigation/index.vue';
import PrivacyAgreement from './privacy-agreement/index.vue';

export default {
  components: {
    Header,
    Search,
    Menu,
    ProcessNavigation,
    Bottom,
    PrivacyAgreement
  },
  data () {
    return {
      count: 0,
      checked: false,
      processList: processList,
      showPrivacyAgreement: false,
      citytitle: ''
    };
  },
  created () {
    const isFromThird = this.$route.query && this.$route.query.from && this.$route.query.from === 'third';
    if (!isFromThird) {
      this.$store.commit('UPDATE_REGISTER_CHECKED', false);
    } else {
      this.checked = this.isChecked;
    }
  },
  mounted () {
    if (this.count === 0 && document.documentElement.scrollTop) {
      document.documentElement.scrollTop = 0;
      this.count++;
    }
  },
  computed: {
    ...mapGetters([
      'isChecked'
    ])
  },
  methods: {
    // 勾选协议
    check (value) {
      if (value) {
        this.$store.commit('UPDATE_REGISTER_CHECKED', value);
      }
    },
    goBack () {
      this.$router.push({
        path: '/register/first-step',
        query: {
          from: 'second'
        }
      });
    },
    next () {
      if (!this.checked) {
        // errorMessage('请先仔细阅读用户服务协议并同意相关条款');
        return;
      };
      this.$router.push('/register/third-step');
    }
  }

};
